import React from "react";
import BaseButton from "./BaseButton";
import { FilterTwoTone } from '@ant-design/icons';

const BaseFilterButton = (props) =>
  <BaseButton type="primary" className={ "filters-button" } { ...props } >{ props.text ? props.text : "Filters" }<FilterTwoTone /></BaseButton>

export default BaseFilterButton;
